

/************************** VIRTUAL CUE OPTIONS ***************************/

/** ------------------------        AVATAR       --------------------------------*/
import vcoMaleGender from '../../assets/images/avatar/male/gender_male.svg';
import vcoFemaleGender from '../../assets/images/avatar/female/gender_female.svg';
import vcoFemaleFace1 from '../../assets/images/avatar/female/extra-01.svg';
import vcoFemaleFace2 from '../../assets/images/avatar/female/extra-02.svg';
import vcoFemaleFace3 from '../../assets/images/avatar/female/extra-03.svg';
import vcoFemaleFace4 from '../../assets/images/avatar/female/extra-04.svg';
import vcoMaleFace1 from '../../assets/images/avatar/male/extra-01.svg';
import vcoMaleFace2 from '../../assets/images/avatar/male/extra-02.svg';
import vcoMaleFace3 from '../../assets/images/avatar/male/extra-03.svg';
import vcoMaleFace4 from '../../assets/images/avatar/male/extra-04.svg';
import vcoFemaleSkin1 from '../../assets/images/avatar/female/skincolor-01.svg';
import vcoFemaleSkin2 from '../../assets/images/avatar/female/skincolor-02.svg';
import vcoFemaleSkin3 from '../../assets/images/avatar/female/skincolor-03.svg';
import vcoFemaleSkin4 from '../../assets/images/avatar/female/skincolor-04.svg';
import vcoMaleSkin1 from '../../assets/images/avatar/male/skincolor-01.svg';
import vcoMaleSkin2 from '../../assets/images/avatar/male/skincolor-02.svg';
import vcoMaleSkin3 from '../../assets/images/avatar/male/skincolor-03.svg';
import vcoMaleSkin4 from '../../assets/images/avatar/male/skincolor-04.svg';
import vcoFemaleGlasses1 from '../../assets/images/avatar/female/glasses-01.svg';
import vcoFemaleGlasses2 from '../../assets/images/avatar/female/glasses-02.svg';
import vcoFemaleGlasses3 from '../../assets/images/avatar/female/glasses-03.svg';
import vcoFemaleGlasses4 from '../../assets/images/avatar/female/glasses-04.svg';
import vcoMaleGlasses1 from '../../assets/images/avatar/male/glasses-01.svg';
import vcoMaleGlasses2 from '../../assets/images/avatar/male/glasses-02.svg';
import vcoMaleGlasses3 from '../../assets/images/avatar/male/glasses-03.svg';
import vcoMaleGlasses4 from '../../assets/images/avatar/male/glasses-04.svg';
import vcoFemaleOutfit1 from '../../assets/images/avatar/female/outfit-01.svg';
import vcoFemaleOutfit2 from '../../assets/images/avatar/female/outfit-02.svg';
import vcoFemaleOutfit3 from '../../assets/images/avatar/female/outfit-03.svg';
import vcoFemaleOutfit4 from '../../assets/images/avatar/female/outfit-04.svg';
import vcoMaleOutfit1 from '../../assets/images/avatar/male/outfit-01.svg';
import vcoMaleOutfit2 from '../../assets/images/avatar/male/outfit-02.svg';
import vcoMaleOutfit3 from '../../assets/images/avatar/male/outfit-03.svg';
import vcoMaleOutfit4 from '../../assets/images/avatar/male/outfit-04.svg';

/** ------------------------        OFFICE       --------------------------------*/
import vcoOffice1 from '../../assets/images/visual-cues-options/officeBuilding-01.svg';
import vcoOffice2 from '../../assets/images/visual-cues-options/officeBuilding-02.svg';
import vcoOffice3 from '../../assets/images/visual-cues-options/officeBuilding-03.svg';
import vcoOffice4 from '../../assets/images/visual-cues-options/officeBuilding-04.svg';
import vcoOfficeOpen1 from '../../assets/images/visual-cues-options/openClosedOfficePlan-01.svg';
import vcoOfficeOpen2 from '../../assets/images/visual-cues-options/openClosedOfficePlan-02.svg';
import vcoOfficeOpen3 from '../../assets/images/visual-cues-options/openClosedOfficePlan-03.svg';
import vcoOfficeOpen4 from '../../assets/images/visual-cues-options/openClosedOfficePlan-04.svg';
import vcoOfficePlants1 from '../../assets/images/visual-cues-options/amountofPlants-01.svg';
import vcoOfficePlants2 from '../../assets/images/visual-cues-options/amountofPlants-02.svg';
import vcoOfficePlants3 from '../../assets/images/visual-cues-options/amountofPlants-03.svg';
import vcoOfficePlants4 from '../../assets/images/visual-cues-options/amountofPlants-04.svg';
import vcoOfficeArt1 from '../../assets/images/visual-cues-options/amountofPaintings-01.svg';
import vcoOfficeArt2 from '../../assets/images/visual-cues-options/amountofPaintings-02.svg';
import vcoOfficeArt3 from '../../assets/images/visual-cues-options/amountofPaintings-03.svg';
import vcoOfficeArt4 from '../../assets/images/visual-cues-options/amountofPaintings-04.svg';
import vcoOfficeSize1 from '../../assets/images/visual-cues-options/sizeofOffice-01.svg';
import vcoOfficeSize2 from '../../assets/images/visual-cues-options/sizeofOffice-02.svg';
import vcoOfficeSize3 from '../../assets/images/visual-cues-options/sizeofOffice-03.svg';
import vcoOfficeSize4 from '../../assets/images/visual-cues-options/sizeofOffice-04.svg';
import vcoOfficeSeating1 from '../../assets/images/visual-cues-options/numberofChairs-01.svg';
import vcoOfficeSeating2 from '../../assets/images/visual-cues-options/numberofChairs-02.svg';
import vcoOfficeSeating3 from '../../assets/images/visual-cues-options/numberofChairs-03.svg';
import vcoOfficeSeating4 from '../../assets/images/visual-cues-options/numberofChairs-04.svg';
import vcoOfficeCouch1 from '../../assets/images/visual-cues-options/couch-01.svg';
import vcoOfficeCouch2 from '../../assets/images/visual-cues-options/couch-02.svg';
import vcoOfficeCouch3 from '../../assets/images/visual-cues-options/couch-03.svg';
import vcoOfficeCouch4 from '../../assets/images/visual-cues-options/couch-04.svg';
import vcoOfficeMirror1 from '../../assets/images/visual-cues-options/mirror-01.svg';
import vcoOfficeMirror2 from '../../assets/images/visual-cues-options/mirror-02.svg';
import vcoOfficeMirror3 from '../../assets/images/visual-cues-options/mirror-03.svg';
import vcoOfficeMirror4 from '../../assets/images/visual-cues-options/mirror-04.svg';

/** ------------------------        PARK       --------------------------------*/
import vcoPark1 from '../../assets/images/visual-cues-options/park-01.svg';
import vcoPark2 from '../../assets/images/visual-cues-options/park-02.svg';
import vcoPark3 from '../../assets/images/visual-cues-options/park-03.svg';
import vcoPark4 from '../../assets/images/visual-cues-options/park-04.svg';

/** ------------------------        HOTEL       --------------------------------*/
import vcoHotel1 from '../../assets/images/visual-cues-options/hotel-01.svg';
import vcoHotel2 from '../../assets/images/visual-cues-options/hotel-02.svg';
import vcoHotel3 from '../../assets/images/visual-cues-options/hotel-03.svg';
import vcoHotel4 from '../../assets/images/visual-cues-options/hotel-04.svg';

/** ------------------------     RESTAURANT    --------------------------------*/
import vcoRestaurant1 from '../../assets/images/visual-cues-options/restaurant-01.svg';
import vcoRestaurant2 from '../../assets/images/visual-cues-options/restaurant-02.svg';
import vcoRestaurant3 from '../../assets/images/visual-cues-options/restaurant-03.svg';
import vcoRestaurant4 from '../../assets/images/visual-cues-options/restaurant-04.svg';

/** ------------------------        EXTRA       --------------------------------*/
import vcoExtra1 from '../../assets/images/visual-cues-options/casino.svg';
import vcoExtra2 from '../../assets/images/visual-cues-options/cinema.svg';
import vcoExtra3 from '../../assets/images/visual-cues-options/gym.svg';
import vcoExtra4 from '../../assets/images/visual-cues-options/opera-house.svg';

/** ------------------------   BUSINESS CARD   --------------------------------*/
import vcoBusinessCard1 from '../../assets/images/visual-cues-options/businessCard-01.svg';
import vcoBusinessCard2 from '../../assets/images/visual-cues-options/businessCard-02.svg';
import vcoBusinessCard3 from '../../assets/images/visual-cues-options/businessCard-03.svg';
import vcoBusinessCard4 from '../../assets/images/visual-cues-options/businessCard-04.svg';

/** ------------------------        CAR        --------------------------------*/
import vcoCar1 from '../../assets/images/visual-cues-options/typeofcar-01.svg';
import vcoCar2 from '../../assets/images/visual-cues-options/typeofcar-02.svg';
import vcoCar3 from '../../assets/images/visual-cues-options/typeofcar-03.svg';
import vcoCar4 from '../../assets/images/visual-cues-options/typeofcar-04.svg';
import vcoCarWindow1 from '../../assets/images/visual-cues-options/glassShade-01.svg';
import vcoCarWindow2 from '../../assets/images/visual-cues-options/glassShade-02.svg';
import vcoCarWindow3 from '../../assets/images/visual-cues-options/glassShade-03.svg';
import vcoCarWindow4 from '../../assets/images/visual-cues-options/glassShade-04.svg';
import vcoCarChair1 from '../../assets/images/visual-cues-options/carSeat-01.svg';
import vcoCarChair2 from '../../assets/images/visual-cues-options/carSeat-02.svg';
import vcoCarChair3 from '../../assets/images/visual-cues-options/carSeat-03.svg';
import vcoCarChair4 from '../../assets/images/visual-cues-options/carSeat-04.svg';
import vcoCarStereo1 from '../../assets/images/visual-cues-options/stereo-01.svg';
import vcoCarStereo2 from '../../assets/images/visual-cues-options/stereo-02.svg';
import vcoCarStereo3 from '../../assets/images/visual-cues-options/stereo-03.svg';
import vcoCarStereo4 from '../../assets/images/visual-cues-options/stereo-04.svg';

/** ------------------------       MEETING     --------------------------------*/
import vcoMeeting1 from '../../assets/images/visual-cues-options/seatingarrangement-01.svg';
import vcoMeeting2 from '../../assets/images/visual-cues-options/seatingarrangement-02.svg';
import vcoMeeting3 from '../../assets/images/visual-cues-options/seatingarrangement-03.svg';
import vcoMeeting4 from '../../assets/images/visual-cues-options/seatingarrangement-04.svg';

/** ------------------------      FOUNTAIN     --------------------------------*/
import vcoFountain1 from '../../assets/images/visual-cues-options/fountain-01.svg';
import vcoFountain2 from '../../assets/images/visual-cues-options/fountain-02.svg';
import vcoFountain3 from '../../assets/images/visual-cues-options/fountain-03.svg';
import vcoFountain4 from '../../assets/images/visual-cues-options/fountain-04.svg';

/** ------------------------      FOUNTAIN     --------------------------------*/
import vcoStatue1 from '../../assets/images/visual-cues-options/statue-01.svg';
import vcoStatue2 from '../../assets/images/visual-cues-options/statue-02.svg';
import vcoStatue3 from '../../assets/images/visual-cues-options/statue-03.svg';
import vcoStatue4 from '../../assets/images/visual-cues-options/statue-04.svg';

/** ------------------------        BOAT       --------------------------------*/
import vcoBoat1 from '../../assets/images/visual-cues-options/sizeofboat-01.svg';
import vcoBoat2 from '../../assets/images/visual-cues-options/sizeofboat-02.svg';
import vcoBoat3 from '../../assets/images/visual-cues-options/sizeofboat-03.svg';
import vcoBoat4 from '../../assets/images/visual-cues-options/sizeofboat-04.svg';


/************************** VIRTUAL CUE REWARDS ********************************/

/** ------------------------       OFFICE      --------------------------------*/
import vcrOffice1 from '../../assets/images/visual-cues-rewards/vcr_officeBuilding-01.svg';
import vcrOffice2 from '../../assets/images/visual-cues-rewards/vcr_officeBuilding-02.svg';
import vcrOffice3 from '../../assets/images/visual-cues-rewards/vcr_officeBuilding-03.svg';
import vcrOffice4 from '../../assets/images/visual-cues-rewards/vcr_officeBuilding-04.svg';

/** ------------------------     RESTAURANT    --------------------------------*/
import vcrRestaurant1 from '../../assets/images/visual-cues-rewards/vcr_restaurant-01.svg';
import vcrRestaurant2 from '../../assets/images/visual-cues-rewards/vcr_restaurant-02.svg';
import vcrRestaurant3 from '../../assets/images/visual-cues-rewards/vcr_restaurant-03.svg';
import vcrRestaurant4 from '../../assets/images/visual-cues-rewards/vcr_restaurant-04.svg';

/** ------------------------        PARK       --------------------------------*/
import vcrPark1 from '../../assets/images/visual-cues-rewards/vcr_park-01.svg';
import vcrPark2 from '../../assets/images/visual-cues-rewards/vcr_park-02.svg';
import vcrPark3 from '../../assets/images/visual-cues-rewards/vcr_park-03.svg';
import vcrPark4 from '../../assets/images/visual-cues-rewards/vcr_park-04.svg';

/** ------------------------        HOTEL       --------------------------------*/
import vcrHotel1 from '../../assets/images/visual-cues-rewards/vcr_hotel-01.svg';
import vcrHotel2 from '../../assets/images/visual-cues-rewards/vcr_hotel-02.svg';
import vcrHotel3 from '../../assets/images/visual-cues-rewards/vcr_hotel-03.svg';
import vcrHotel4 from '../../assets/images/visual-cues-rewards/vcr_hotel-04.svg';

/** ------------------------        EXTRA       --------------------------------*/
import vcrExtra1 from '../../assets/images/visual-cues-rewards/vcr_casino-01.svg';
import vcrExtra2 from '../../assets/images/visual-cues-rewards/vcr_cinema-02.svg';
import vcrExtra3 from '../../assets/images/visual-cues-rewards/vcr_gym-03.svg';
import vcrExtra4 from '../../assets/images/visual-cues-rewards/vcr_operahouse-04.svg';

/** ------------------------      LIGHTHOUSE       --------------------------------*/
import vcrLighthouse from '../../assets/images/visual-cues-rewards/vcr_lighthouse.svg';

/**************************       PEOPLE      ********************************/

/** ------------------------      PLAYERS       --------------------------------*/
import player2 from '../../assets/images/players/player2.svg';
import player3 from '../../assets/images/players/player3.svg';
import player4 from '../../assets/images/players/player4.svg';

/** ------------------------   EXTRA PEOPLE    --------------------------------*/
import extraPerson1 from '../../assets/images/players/extra_lady1.svg';
import extraPerson2 from '../../assets/images/players/extra_lady2.svg';
import extraPerson3 from '../../assets/images/players/extra_lady3.svg';
import extraPerson4 from '../../assets/images/players/extra_man1.svg';
import extraPerson5 from '../../assets/images/players/extra_man2.svg';
import extraPerson6 from '../../assets/images/players/extra_man3.svg';


const virtualCueOptions = {
	"female": vcoFemaleGender,
	"male": vcoMaleGender,
	"female-face-1": vcoFemaleFace1,
	"female-face-2": vcoFemaleFace2,
	"female-face-3": vcoFemaleFace3,
	"female-face-4": vcoFemaleFace4,
	"male-face-1": vcoMaleFace1,
	"male-face-2": vcoMaleFace2,
	"male-face-3": vcoMaleFace3,
	"male-face-4": vcoMaleFace4,
	"female-skin-1": vcoFemaleSkin1,
	"female-skin-2": vcoFemaleSkin2,
	"female-skin-3": vcoFemaleSkin3,
	"female-skin-4": vcoFemaleSkin4,
	"male-skin-1": vcoMaleSkin1,
	"male-skin-2": vcoMaleSkin2,
	"male-skin-3": vcoMaleSkin3,
	"male-skin-4": vcoMaleSkin4,
	"female-glasses-1": vcoFemaleGlasses1,
	"female-glasses-2": vcoFemaleGlasses2,
	"female-glasses-3": vcoFemaleGlasses3,
	"female-glasses-4": vcoFemaleGlasses4,
	"male-glasses-1": vcoMaleGlasses1,
	"male-glasses-2": vcoMaleGlasses2,
	"male-glasses-3": vcoMaleGlasses3,
	"male-glasses-4": vcoMaleGlasses4,
	"female-outfit-1": vcoFemaleOutfit1,
	"female-outfit-2": vcoFemaleOutfit2,
	"female-outfit-3": vcoFemaleOutfit3,
	"female-outfit-4": vcoFemaleOutfit4,
	"male-outfit-1": vcoMaleOutfit1,
	"male-outfit-2": vcoMaleOutfit2,
	"male-outfit-3": vcoMaleOutfit3,
	"male-outfit-4": vcoMaleOutfit4,
	"male-with-glasses": vcoMaleGlasses3,
	"male-without-glasses": vcoMaleGender,
	"female-with-glasses": vcoFemaleGlasses3,
	"female-without-glasses": vcoFemaleGender,

	"office-1": vcoOffice1,
	"office-2": vcoOffice2,
	"office-3": vcoOffice3,
	"office-4": vcoOffice4,
	"office-open-1": vcoOfficeOpen1,
	"office-open-2": vcoOfficeOpen2,
	"office-open-3": vcoOfficeOpen3,
	"office-open-4": vcoOfficeOpen4,
	"office-plants-1": vcoOfficePlants1,
	"office-plants-2": vcoOfficePlants2,
	"office-plants-3": vcoOfficePlants3,
	"office-plants-4": vcoOfficePlants4,
	"office-art-1": vcoOfficeArt1,
	"office-art-2": vcoOfficeArt2,
	"office-art-3": vcoOfficeArt3,
	"office-art-4": vcoOfficeArt4,
	"office-size-1": vcoOfficeSize1,
	"office-size-2": vcoOfficeSize2,
	"office-size-3": vcoOfficeSize3,
	"office-size-4": vcoOfficeSize4,
	"office-seating-1": vcoOfficeSeating1,
	"office-seating-2": vcoOfficeSeating2,
	"office-seating-3": vcoOfficeSeating3,
	"office-seating-4": vcoOfficeSeating4,
	"office-couch-1": vcoOfficeCouch1,
	"office-couch-2": vcoOfficeCouch2,
	"office-couch-3": vcoOfficeCouch3,
	"office-couch-4": vcoOfficeCouch4,
	"office-mirror-1": vcoOfficeMirror1,
	"office-mirror-2": vcoOfficeMirror2,
	"office-mirror-3": vcoOfficeMirror3,
	"office-mirror-4": vcoOfficeMirror4,

	"restaurant-1": vcoRestaurant1,
	"restaurant-2": vcoRestaurant2,
	"restaurant-3": vcoRestaurant3,
	"restaurant-4": vcoRestaurant4,

	"park-1": vcoPark1,
	"park-2": vcoPark2,
	"park-3": vcoPark3,
	"park-4": vcoPark4,

	"hotel-1": vcoHotel1,
	"hotel-2": vcoHotel2,
	"hotel-3": vcoHotel3,
	"hotel-4": vcoHotel4,

	"extra-1": vcoExtra1,
	"extra-2": vcoExtra2,
	"extra-3": vcoExtra3,
	"extra-4": vcoExtra4,

	"business-card-1": vcoBusinessCard1,
	"business-card-2": vcoBusinessCard2,
	"business-card-3": vcoBusinessCard3,
	"business-card-4": vcoBusinessCard4,

	"car-1": vcoCar1,
	"car-2": vcoCar2,
	"car-3": vcoCar3,
	"car-4": vcoCar4,
	"car-window-1": vcoCarWindow1,
	"car-window-2": vcoCarWindow2,
	"car-window-3": vcoCarWindow3,
	"car-window-4": vcoCarWindow4,
	"car-chair-1": vcoCarChair1,
	"car-chair-2": vcoCarChair2,
	"car-chair-3": vcoCarChair3,
	"car-chair-4": vcoCarChair4,
	"car-stereo-1": vcoCarStereo1,
	"car-stereo-2": vcoCarStereo2,
	"car-stereo-3": vcoCarStereo3,
	"car-stereo-4": vcoCarStereo4,

	"meeting-1": vcoMeeting1,
	"meeting-2": vcoMeeting2,
	"meeting-3": vcoMeeting3,
	"meeting-4": vcoMeeting4,

	"fountain-1": vcoFountain1,
	"fountain-2": vcoFountain2,
	"fountain-3": vcoFountain3,
	"fountain-4": vcoFountain4,

	"statue-1": vcoStatue1,
	"statue-2": vcoStatue2,
	"statue-3": vcoStatue3,
	"statue-4": vcoStatue4,

	"boat-1": vcoBoat1,
	"boat-2": vcoBoat2,
	"boat-3": vcoBoat3,
	"boat-4": vcoBoat4,
}

const virtualCueRewards = {
	"office-1": vcrOffice1,
	"office-2": vcrOffice2,
	"office-3": vcrOffice3,
	"office-4": vcrOffice4,

	"restaurant-1": vcrRestaurant1,
	"restaurant-2": vcrRestaurant2,
	"restaurant-3": vcrRestaurant3,
	"restaurant-4": vcrRestaurant4,

	"park-1": vcrPark1,
	"park-2": vcrPark2,
	"park-3": vcrPark3,
	"park-4": vcrPark4,

	"hotel-1": vcrHotel1,
	"hotel-2": vcrHotel2,
	"hotel-3": vcrHotel3,
	"hotel-4": vcrHotel4,

	"extra-1": vcrExtra1,
	"extra-2": vcrExtra2,
	"extra-3": vcrExtra3,
	"extra-4": vcrExtra4,

	"lighthouse": vcrLighthouse,
}

const players = {
	"player-2": player2,
	"player-3": player3,
	"player-4": player4,
}

const people = {
	"irene": extraPerson1,
	"john": extraPerson5,
	"jack": extraPerson6,
	"diamanda": extraPerson2,
	"steve": extraPerson4,
	"camae": extraPerson3
}

export { virtualCueOptions, virtualCueRewards, players, people }
